export const LOCALES = {
    ENGLISH: "en",  // BCP-47 format (lowercase)
    BULGARIAN: 'bg',  // BCP-47 format (lowercase)
    TURKISH: 'tr'  // BCP-47 format (lowercase)
};